import { Badge } from '@/components/ui/badge';
import type { KnowledgeBaseVaultPage } from '@/components/knowledge/types';

interface VaultPageHeaderProps {
  page: KnowledgeBaseVaultPage;
  linkedPagesCount: number;
}

export default function VaultPageHeader({ page, linkedPagesCount }: VaultPageHeaderProps) {
  return (
    <div className="rounded-lg border bg-card p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold">{page.title}</h3>
          <p className="text-sm text-muted-foreground">{page.path}</p>
        </div>
        <Badge variant="secondary" className="capitalize">
          {page.page_type.replace('-', ' ')}
        </Badge>
      </div>
      <div className="mt-3 flex flex-wrap gap-2 text-xs text-muted-foreground">
        <span>Updated {new Date(page.updated_at).toLocaleString()}</span>
        <span>•</span>
        <span>{page.source_document_ids.length} source{page.source_document_ids.length === 1 ? '' : 's'}</span>
        <span>•</span>
        <span>{linkedPagesCount} linked page{linkedPagesCount === 1 ? '' : 's'}</span>
      </div>
    </div>
  );
}
